export default __webpack_public_path__ + "static/media/quatr.78c3115b.jpg";